import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { ComponentView } from 'src/modules/app-template/models/component-view.model';
import { ObjectOfSimpleDataTypes } from 'src/modules/utils/shared/object-of-simple-data-types.model';
import { RestEndpoint } from '../../models/rest-endpoint.model';
import { TableData } from '../../models/table-data.model';
import { TableRow } from '../../models/table-row.model';
import { TableSortColumn } from '../../models/table-sort-column.model';
import { GenericObjectDefinition } from '../../netgen/GenericObjectDefinition';
import { TableCellType } from '../../netgen/TableCellType';
import { TableColumn } from '../../netgen/TableColumn';

@Component({
    selector: 'admin-object-list',
    templateUrl: './admin-object-list.component.html',
    styleUrls: ['./admin-object-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AdminObjectListComponent extends ComponentView {

    neededParams: ObjectOfSimpleDataTypes = { 
        scope: "string",
        id: "string"
     };
    
    @Input()
    scope: string;
    @Input()
    id: string;

    def: GenericObjectDefinition;
    data: any[] = [];
    table: TableData;
    
    
    async initParams(): Promise<boolean> {
        this.def = this.app.mainConfig.genericObjectDefinitions.find(item => item.scope == this.scope && item.id == this.id);
        this.data = await this.app.loadDataHandler(async () => RestEndpoint.main().run(this.def.apiEndpoint).listObjects(), this);

        this.table = new TableData([
            new TableColumn("label", "Name", TableCellType.string, -1)
        ], this.data.map(o => new TableRow("", o, {
            label: o.label
        })), ["label"]);
        
        this.updateNavigation(null, [
            { label: "Administration", routerLink: ["/base2", "admin"] },
            { label: this.def.title, routerLink: ["/base2", "admin", "generic-list", this.scope, this.id] }
        ]);
        return true;
    }

    async rowSelect(row: TableRow): Promise<void> {
        await this.app.navigateTo(["/base2", "admin", "generic-edit", this.scope, this.id, row.raw.key]);
    }
}
